// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/columns-2.js';

import { paths } from '../generated/columns-2';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('columns-2', Original, paths);
